import React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useStyles } from './style';
import { Icons } from 'components';
import clsx from 'clsx';
import { Typography, Avatar, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import { useCopy, useMenu } from 'hooks';

export default function MenuListComposition({ business, signOut, isLoading }) {
  const classes = useStyles();
  const params = useParams();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const navigate = useNavigate();
  const { copyItem } = useCopy();
  const permission = useMenu();
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  React.useEffect(() => {
    checkRedirectStorage();
    if (
      !localStorage.getItem('TOKEN') ||
      (!localStorage.getItem('TOKEN') && window.location.pathname.toLowerCase().includes('getfile'))
    ) {
      if (window.location.pathname.toLowerCase().includes('getfile')) {
        localStorage.setItem(
          'fileHashCode',
          window.location.pathname.split('/').reverse()[0] + window.location.search,
        );
        localStorage.setItem('fileHashTimeExpire', new Date());
      }
      navigate('/sign-in');
    }
  }, []);
  React.useEffect(() => { }, [permission]);

  const redirectTo = (url, e) => {
    handleClose(e);
    navigate(url);
  };

  /**
   * چک میکند در صورتیکه کاربر قبلا ریدایکرت ذخیره شده باشد ، به صفحه مورد نظر منتقل میشود
   */
  const checkRedirectStorage = () => {
    if (
      localStorage.getItem('TOKEN') &&
      localStorage.getItem('redirectUrl') &&
      localStorage.getItem('dateTimeRedirect')
    ) {
      const link = localStorage.getItem('redirectUrl');
      const dateTimeRedirect = localStorage.getItem('dateTimeRedirect');
      const date1 = new Date(dateTimeRedirect);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      const minuts = Math.ceil(diffTime / (1000 * 60)); // munits
      if (minuts < 11) {
        localStorage.removeItem('redirectUrl');
        localStorage.removeItem('dateTimeRedirect');
        return navigate(link);
      } else {
        localStorage.removeItem('redirectUrl');
        localStorage.removeItem('dateTimeRedirect');
      }
    }
    if (localStorage.getItem('TOKEN') && localStorage.getItem('fileHashCode')) {
      const fileHashCode = localStorage.getItem('fileHashCode');
      const t = localStorage.getItem('fileHashTimeExpire');
      const date1 = new Date(t);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      const minuts = Math.ceil(diffTime / (1000 * 60)); // munits
      if (minuts < 10) {
        fileHashCode && navigate(`/GetFile/${fileHashCode}`);
      } else {
        localStorage.removeItem('fileHashCode');
        localStorage.removeItem('fileHashTimeExpire');
      }
    }
  };
  return (
    <div className={classes.root}>
      <Button
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        className={`${classes.mainButton} ${open ? 'active' : ''}`}
        startIcon={
          !business?.hasOwnProperty('id') ? (
            <Skeleton variant="circular" className={classes.avatarLoading} />
          ) : business?.image ? (
            <Avatar alt="لوگو کسب‌وکار" src={business?.image} className={classes.avatar} />
          ) : (
            <Icons icon="userCircle" color="#333" size="22" className={classes.avatar} />

          )
        }
        disableRipple
        endIcon={open ? <Icons icon="CaretUp" color="#333" size="22" className={classes.avatar} /> : <Icons icon="CaretDown" color="#333" size="22" className={classes.avatar} />
        }
      >
        <div className={classes.normalTitleContainer}>
          {!business?.hasOwnProperty('id') ? (
            <Skeleton variant="text" width={35} height={15} />
          ) : null}
          {business?.name}
          <Typography component="div" className={`${classes.bizEnName} ${open ? 'show' : ''}`}>
            {business?.username}
          </Typography>
        </div>
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        className={classes.popper}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              marginInlineStart: 2,
              transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
            }}
          >
            <Paper elevation={0} className={clsx(classes.paper, { [classes.opened]: open })}>
              <ClickAwayListener onClickAway={handleClose}>
                <div style={{ paddingInlineStart: 4, marginInlineStart: -1 }}>
                  <div className={classes.bizDetail}>
                    <Typography
                      className={classes.detailItem}
                      onClick={() => copyItem(business?.id ?? '', 'شناسه کسب‌وکار کپی شد!')}
                    >
                      شناسه کسب‌و‌کار
                      <span>{business?.id}</span>
                    </Typography>
                    <Typography
                      className={classes.detailItem}
                      onClick={() => copyItem(business?.userId ?? '', 'شناسه کاربر کپی شد!')}
                    >
                      شناسه کاربر
                      <span>{business?.userId}</span>
                    </Typography>
                    <Typography
                      className={classes.detailItem}
                      onClick={() => copyItem(business?.ssoId ?? '', 'شناسه SSO کپی شد!')}
                    >
                      شناسه SSO
                      <span dir="ltr">{business?.ssoId ?? '-'}</span>
                    </Typography>
                  </div>

                  {/* <> */}
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    {permission && permission.find((a) => a.key == 'businessInfo/read') ? (
                      <MenuItem
                        onClick={(e) => redirectTo('/BusinessInfo', e)}
                        className={classes.menuItem}
                      >
                        <Icons icon="editPen" color="#333" size="18" className={classes.menuIcon} />

                        ویرایش اطلاعات کسب‌و‌کار
                      </MenuItem>
                    ) : null}

                    {permission && permission.find((a) => a.key == 'user-management/read') ? (
                      <MenuItem
                        className={classes.menuItem}
                        onClick={(e) => redirectTo('/user-settings', e)}
                      >
                        <Icons icon="ServiceManagment" color="#333" size="18" className={classes.menuIcon} />

                        مدیریت کاربری
                      </MenuItem>
                    ) : null}

                    <MenuItem className={classes.menuItem} onClick={isLoading ? '' : signOut}>
                      {isLoading ? (
                        <CircularProgress size={20} className={classes.buttonProgress} />
                      ) : (
                        <>
                          <Icons icon="logout" color="#333" size="18" className={classes.menuIcon} />
                          <span>خروج</span>
                        </>
                      )}
                    </MenuItem>
                  </MenuList>
                </div>
                {/* </> */}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
